import styled from "styled-components";
import AppWrapper from "../../layout/AppWrapper";
import Title from "../../utils/Title";
import AllWaybill from "../../components/user/waybill/AllWaybill";


function Waybill() {

  return (
    <>
      <AppWrapper
        pagename={"waybill"}
      >
        <StyledWaybill>
          <Title title={"Waybill"} btnName={""} />
        </StyledWaybill>

        <AllWaybill />


      </AppWrapper>

    </>
  );
}

export default Waybill;

const StyledWaybill = styled.div`
  

`;